<template>
  <el-dialog
    :title="$t('store::album::log_同步商品专辑')"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="690px"
    @closed="close"
  >
    <p slot="title">{{ $t('store::album::log_同步商品专辑') }}</p>

    <div>
      <div class="title">
        <span>{{ $t('store::album::log_选择店铺') }}：</span>
        <el-select
          style="width: 280px; margin-bottom: 16px"
          v-model="shopId"
          :placeholder="$t('store::album::log_请选择店铺')"
          @change="selectShop"
          :disabled="!!defaultShopId"
        >
          <el-option v-for="item in shopList" :key="item.value" :label="item.label" :value="item.value">
            <span style="float: left">{{ item.label }}</span>
            <el-badge :value="item.num" :max="99" v-show="item.num" class="select-badge"></el-badge>
          </el-option>
        </el-select>
        <div style="color: #666">{{ $t('store::album::log_同步tip') }}</div>
      </div>
      <p style="font-weight: bold; margin-bottom: 24px">
        {{ $t('store::album::log_请选择需要同步的专辑') }}
        <span style="font-size: 12px; color: #ff4d00; margin-left: 16px">
          <i class="el-icon-warning"></i>
          {{ $t('store::album::log_同步title') }}
        </span>
      </p>
      <z-table
        :columns="columns"
        :data="tableData"
        ref="table"
        @selection-change="handleSelectTable"
        v-loading="loading"
        :pagination="false"
        :maxHeight="300"
        :customDefault="{
          height: '300px',
        }"
      >
        <template #no="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
        <template #title="{ row }">
          <div class="table-title">
            <ZImg :src="row.collectionImage" class="images"></ZImg>
            <span style="margin-left: 16px; flex: 1">{{ row.title }}</span>
          </div>
        </template>
        <template #status="{ row }">
          <div style="display: flex; align-items: center">
            <i :class="`status-icon status${row.status}`"></i>
            <span style="margin: 0 8px">{{ statusConfig[row.status] }}</span>
          </div>
        </template>
      </z-table>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancel">
        {{ $t('system::common::btn::cancel') }}
      </el-button>
      <el-button size="small" type="primary" :loading="sumbitLoading" @click="sumbit">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getSyncList, getSyncShopList, syncAlbum } from '@/server/album'
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    defaultShopId: {
      default: false,
    },
  },
  data() {
    return {
      visible: this.value,
      loading: false,
      sumbitLoading: false,
      shopList: [],
      shopId: '',
      columns: [
        {
          type: 'selection',
          fixed: true,
        },
        {
          label: this.$t('store::album::log_序号'),
          prop: 'no',
          minWidth: 80,
        },
        {
          label: this.$t('store::album::log_店铺'),
          prop: 'shopName',
          minWidth: 150,
        },
        {
          label: this.$t('store::album::log_专辑标题'),
          prop: 'title',
          minWidth: 200,
        },
        {
          label: this.$t('store::album::log_变更'),
          prop: 'status',
          minWidth: 150,
        },
      ],
      tableData: [],
      selection: [],
      statusConfig: {
        0: this.$t('system::common::text::add'),
        1: this.$t('system::function::edit'),
        2: this.$t('system::function::delete'),
      },
    }
  },
  watch: {
    visible: {
      handler(val) {
        this.$emit('input', val)
        if (val) {
          this.init()
          if (this.defaultShopId) this.shopId = this.defaultShopId
        }
      },
      immediate: true,
    },
    value(val) {
      this.visible = val
    },
  },
  methods: {
    async init() {
      await this.getShopList()
      this.getAlbumList()
    },
    async getShopList() {
      const { data } = await getSyncShopList()
      if (Array.isArray(data.data)) {
        this.shopList = data.data.map(item => {
          return {
            label: item.shopName,
            value: item.shopId,
            num: item.total,
          }
        })
        this.shopId = this.shopList[0].value
      }
    },
    selectShop(val) {
      this.selection = []
      this.$refs.table.$refs.elTable && this.$refs.table.$refs.elTable.clearSelection()
      this.getAlbumList()
    },
    handleSelectTable(selection) {
      this.selection = selection
    },
    async getAlbumList() {
      this.loading = true
      const data = await getSyncList({ shopId: this.shopId })
      if (data.data.code === this.$code) {
        this.tableData = data.data.data
      }
      this.loading = false
    },
    cancel() {
      this.visible = false
    },
    async sumbit() {
      if (!this.selection.length) {
        this.$message.error(this.$t('store::album::log_请选择专辑'))
        return
      }
      this.sumbitLoading = true
      let data = await syncAlbum(this.selection)
      if (data.data.code === this.$code) {
        this.$message.success('同步成功')
        this.$emit('save')
        this.visible = false
      }
      this.sumbitLoading = false
    },
    close() {
      this.selection = []
      this.$refs.table.$refs.elTable && this.$refs.table.$refs.elTable.clearSelection()
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 32px;
}
.title {
  margin-bottom: 40px;
}
.icondianpuliebiao {
  color: #0560fd;
}
.dialog-footer {
  text-align: center;
}
.select-badge {
  float: right;
  /deep/ sup {
    top: 0;
  }
}
.status-icon {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
  background: #ff9e00;
}
.status1 {
  background: #0061ff;
}
.status2 {
  background: #ff0022;
}
.status0 {
  background: #ff9e00;
}
.table-title {
  display: flex;
  align-items: center;
  padding: 5px 0;
}
.images {
  height: 43px;
  width: 43px;
}
</style>
